import ImportFile from './ImportFile' 

export default (Vue)=>{
  Vue.component("ImportFile", ImportFile )  // 前者必须是字符串格式，后者是组件
}